import { toastError, toastWarning } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

export const onUpdateEOD = async (id, selectedDesignIds, eoDate) => {
	try {
		const { data } = await ApiClient.PUT(
			'updateEOD',
			{},
			`${id}/eod?itemIds=${selectedDesignIds}&eod=${eoDate}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const completeReview = async (productIds) => {
	try {
		const { data } = await ApiClient.POST('completeReview', {}, `?productIds=${productIds}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getExFactorySupplierQuote = async (quoteId) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/supplier-quote/${quoteId}/ex-factory`, '', true);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateExFactorySupplierQuote = async (quoteId, requestBody) => {
	try {
		const { data } = await ApiClient.PUT(
			`${BASE_URL}/rfq/${quoteId}/ex-factory-info`,
			requestBody,
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateDeliveryDate = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST(`updateEtd`, requestBody);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const tagSupplierQuote = async (supplierId, requestBody) => {
	try {
		const { data } = await ApiClient.POST('tagQuoteSupplier', requestBody, supplierId);
		return data;
	} catch ({ response }) {
		if (response && response.data && response.data.message) {
			toastWarning(response.data.message);
		} else {
			toastError('Request was unsuccessful.');
		}
	}
};
